import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { api } from '../api/client';
export default function AddBlockMenu({ onPick }) {
    const [open, setOpen] = useState(false);
    const [catalog, setCatalog] = useState(null);
    const [filter, setFilter] = useState('');
    const ref = useRef(null);
    useEffect(() => {
        if (!open || catalog)
            return;
        api.catalog().then((c) => setCatalog({ categories: c.categories, blocks: c.blocks })).catch(() => { });
    }, [open, catalog]);
    useEffect(() => {
        if (!open)
            return;
        function onDocClick(e) {
            if (ref.current && !ref.current.contains(e.target))
                setOpen(false);
        }
        function onKey(e) { if (e.key === 'Escape')
            setOpen(false); }
        document.addEventListener('mousedown', onDocClick);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDocClick);
            document.removeEventListener('keydown', onKey);
        };
    }, [open]);
    const grouped = useMemo(() => {
        if (!catalog)
            return [];
        const f = filter.trim().toLowerCase();
        const matches = (b) => f === '' ||
            b.type.toLowerCase().includes(f) ||
            b.name.toLowerCase().includes(f) ||
            (b.tags ?? []).some((t) => t.toLowerCase().includes(f));
        return catalog.categories.map((cat) => ({
            ...cat,
            items: catalog.blocks.filter((b) => b.category === cat.id && matches(b)),
        })).filter((g) => g.items.length > 0);
    }, [catalog, filter]);
    return (_jsxs("div", { className: "add-menu", ref: ref, children: [_jsx("button", { onClick: () => setOpen((o) => !o), children: "+ Add block" }), open && (_jsxs("div", { className: "add-menu-pop", children: [_jsx("input", { autoFocus: true, type: "text", placeholder: "Search blocks\u2026", value: filter, onChange: (e) => setFilter(e.target.value) }), _jsxs("div", { className: "add-menu-list", children: [!catalog && _jsx("div", { className: "muted pad", children: "Loading\u2026" }), grouped.map((g) => (_jsxs("div", { className: "cat", children: [_jsx("div", { className: "cat-name", children: g.name }), g.items.map((b) => (_jsx("button", { type: "button", className: "cat-item", onClick: () => { setOpen(false); setFilter(''); onPick(b); }, children: _jsxs("div", { children: [_jsx("div", { className: "cat-item-name", children: b.name }), _jsx("div", { className: "cat-item-desc", children: b.description })] }) }, b.type + (b.layout ?? ''))))] }, g.id))), catalog && grouped.length === 0 && _jsx("div", { className: "muted pad", children: "No matches." })] })] }))] }));
}
